module.exports = __webpack_public_path__ + "static/img/wenhao.477a5ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/header1/img/wenhao.png
// module id = 309
// module chunks = 40 41 42